import { useState } from 'react'
import AdminPanelCN from 'components/AdminPanelCN/AdminPanelCN'
import HeaderCN from 'components/HeaderCN/HeaderCN'
import VendorCard from 'features/Vendors/components/VendorCard'
import { VENDORS, sortVendors } from 'features/Vendors/vendors'

/**
 * ADMIN > Vendors (MYD-658): the third parties participating in MDT.
 *
 * Not gated on `isAdmin`, like Help Docs. The Admin group is visible to every
 * desktop user, and these cards are offers aimed at those users.
 */

const VendorsScreen = () => {
	const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

	return (
		<div className="flex h-screen overflow-hidden bg-gray-50">
			<AdminPanelCN mobileOpen={mobileMenuOpen} onMobileClose={() => setMobileMenuOpen(false)} />

			<div className="flex flex-1 flex-col overflow-hidden">
				<HeaderCN onMobileMenuToggle={() => setMobileMenuOpen(!mobileMenuOpen)} />

				<main className="flex-1 overflow-y-auto p-6">
					<div className="mx-auto max-w-[1200px]">
						<h2 className="text-2xl font-semibold text-gray-800">Vendors</h2>
						<p className="mt-1 text-sm text-gray-600">Third parties participating in MYDealTeams.</p>

						{/* auto-fill rather than breakpoints: the width that matters here
						    moves with the sidebar collapsing, not just the viewport. */}
						<div className="mt-6 grid grid-cols-[repeat(auto-fill,minmax(250px,1fr))] gap-4">
							{sortVendors(VENDORS).map(vendor => (
								<VendorCard key={vendor.id} vendor={vendor} />
							))}
						</div>
					</div>
				</main>
			</div>
		</div>
	)
}

export default VendorsScreen
